import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Panel.less';

const cx = classnames.bind(styles);

export default React.memo(Panel);

Panel.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
};

/**
 * **Access:**
 * ```js
 * import {Panel} from '@iss/client-react-components'
 * ```
 * Privides a common panel container
 *
 * @class Panel
 * @component
 */
function Panel({ as: Element = 'div', className, ...props }) {
  return <Element className={cx('root', className)} {...props} />;
}
